/* eslint-disable */
/**
 * Trust All Scripts
 *
 * This is a dirty little script for iterating over script tags
 * of your Ghost posts and adding them to the document head.
 *
 * This works for any script that then injects content into the page
 * via ids/classnames etc.
 *
 */
var trustAllScripts = require('./src/utils/trustAllScripts').default;

exports.onRouteUpdate = function() {
  trustAllScripts();
};

exports.onClientEntry = () => {
  // if (!document.cookie.includes(process.env.TSR_ADS_SERVICE_COOKIE_NAME)) {
  //   const services = ['adthrive', 'adsense'];
  //   const name = services[Math.round(Math.random())];
  //   document.cookie = `${process.env.TSR_ADS_SERVICE_COOKIE_NAME}=${name};path=/`;
  // }
};
